import { jsx as _jsx } from "react/jsx-runtime";
import { Suspense } from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { RoutesList } from "./routesList";
import { MainPage } from "@/features/main/pages/MainPage";
export var AppRouter = function () {
    var router = createBrowserRouter([
        {
            path: RoutesList.Main,
            element: _jsx(Suspense, { fallback: "Loading...", children: _jsx(MainPage, {}) })
        }
    ]);
    return _jsx(RouterProvider, { router: router });
};
